module.exports = __webpack_public_path__ + "img/workout-notebook_B095QJ6KGP.8c5e3b46.jpg";